import React, { useState } from 'react';
import styled from 'styled-components';
import GlobalStyles from './styles/GlobalStyles';
import Portal from './components/animations/Portal';
import Navbar from './components/navigation/Navbar';
import MainContent from './components/sections/MainContent';
import Footer from './components/Footer';

const AppContainer = styled.div`
  min-height: 100vh;
  background-color: var(--color-primary);
  display: flex;
  flex-direction: column;
`;

const MainWrapper = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`;

const App: React.FC = () => {
  const [isMainContentVisible, setIsMainContentVisible] = useState(false);
  const [isPortalVisible, setIsPortalVisible] = useState(true);
  const [currentSection, setCurrentSection] = useState('accueil');

  const handlePortalEnter = () => {
    setIsPortalVisible(false);
    setIsMainContentVisible(true);
  };

  return (
    <AppContainer>
      <GlobalStyles />
      {isPortalVisible ? (
        <Portal onPortalEnter={handlePortalEnter} />
      ) : (
        <MainWrapper>
          <Navbar 
            currentSection={currentSection}
            onSectionChange={setCurrentSection}
            isVisible={isMainContentVisible}
          />
          <MainContent 
            isVisible={isMainContentVisible}
            currentSection={currentSection}
          />
          <Footer />
        </MainWrapper>
      )}
    </AppContainer>
  );
};

export default App;
